// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"251":"291fbab3","299":"372a4fa2","356":"7fe45e3b"}[chunkId] + ".js";
};